import baseURL from "../common/axios";
class LiveCallService {
  //To Insert LiveCalls-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("LiveCalls/Create", dataModel);
  }
  //To Update LiveCalls-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("LiveCalls/Update", dataModel);
  }
  //To Delete LiveCalls-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("LiveCalls/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "LiveCalls/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get LiveCalls List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("LiveCalls/List");
  }
  //To Get LiveCalls List-->MOPCRM API
  getCallList() {
    return baseURL.httpMSMOPCRMUrl.get("LiveCalls/CallList");
  }

  CallLogsListCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "LiveCalls/ListCallLogsCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }

  //To Get LiveCalls List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("LiveCalls/Get?id=" + Id + "");
  }
  //To Get LiveCalls List-->MOPCRM API
  updatethelog(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("LiveCalls/UpdateByCallId", dataModel);
  }

  GetDashboardListCustom(agentdid, admin, clientId, flag) {
    return baseURL.httpMSMOPCRMUrl.get(
      "LiveCalls/GetDashboardCustom?agentdid=" +
      agentdid +
      "&admin=" +
      admin +
      "&clientId=" +
      clientId +
      "&flag=" +
      flag
    );
  }


  GetDashboardCallListCustom(agentdid, admin, clientId, flag) {
    return baseURL.httpMSMOPCRMUrl.get(
      "LiveCalls/GetDashBoardCallLogsCustom?agentdid=" +
      agentdid +
      "&admin=" +
      admin +
      "&clientId=" +
      clientId +
      "&flag=" +
      flag
    );
  }
}
export default new LiveCallService();
